module.exports = __webpack_public_path__ + "img/omniva.8fc8ca66.png";